import { CrudTableService } from '@/components/business/crud/service/CrudTableService';
import { windows } from '@/components/common/window/Windows';
import { shallowRef } from 'vue';
import { message, Modal } from 'ant-design-vue';
import { request } from '@/util/request';
import ProxySelect from '@/views/management/device/bind/ProxySelect.vue';
import BindProxy from '@/views/management/device/bind/BindProxy.vue';
import BindCode from '@/views/management/device/BindCode.vue';

export default class DeviceTable extends CrudTableService {
  async init() {
    this.widgetContainer.addButton('showCode', {
      type: 'table',
      icon: 'BarcodeOutlined',
      text: '绑定码',
      handler: async () => {
        windows.open({
          content: {
            type: 'component',
            component: shallowRef(BindCode),
          },
          mask: true,
          width: 600,
          height: 600,
          title: '设备绑定码',
        });
      },
    });
    this.widgetContainer.addButton('openProxy', {
      type: 'select',
      text: '开启代理',
      icon: 'CheckCircleOutlined',
      handler: async (rows: any) => this.setProxy(rows, true),
    });
    this.widgetContainer.addButton('closeProxy', {
      type: 'select',
      text: '关闭代理',
      icon: 'StopOutlined',
      handler: async (rows: any) => this.setProxy(rows, false),
    });
    this.widgetContainer.addButton('bind', {
      type: 'select',
      icon: 'ShrinkOutlined',
      text: '绑定线路',
      handler: async (rows: any) => {
        if (rows.length === 0) {
          message.info('未选中设备');
          return;
        }
        const selectWindowId = windows.open({
          content: {
            type: 'component',
            component: shallowRef(ProxySelect),
          },
          width: 1200,
          title: '选择要绑定的线路',
        });
        const selectRes = await windows.getCloseData(selectWindowId);
        if (!selectRes) {
          return;
        }
        const { selected, num } = selectRes;
        if (selected.length === 0) {
          message.error('未选中线路');
          return;
        }
        const id = windows.open({
          content: {
            type: 'component',
            component: shallowRef(BindProxy),
            props: {
              proxies: selected,
              devices: rows,
              num,
            },
          },
          title: '绑定线路',
        });
        const res = await windows.getCloseData(id);
        if (res) {
          await this.refreshList();
        }
      },
    });
    this.widgetContainer.addButton('unbind', {
      type: 'select',
      icon: 'ArrowsAltOutlined',
      text: '解绑线路',
      handler: async (rows: any) => {
        if (rows.length === 0) {
          message.info('未选中设备');
          return;
        }
        Modal.confirm({
          title: '确定要解绑这' + rows.length + '个设备的线路的？',
          onOk: async () => {
            const res = await request('management/device/unbind', {
              ids: rows.map((i: any) => i.id),
            });
            if (res) {
              await this.refreshList();
            }
          },
        });
      },
    });

    await super.init();
  }

  private async  setProxy(rows: any[], proxySetting: boolean) {
    if (rows.length === 0) {
      message.info('未选中设备');
      return;
    }
    const text = proxySetting ? "开启" : "关闭"
    const confirm = await new Promise((resolve) => {
      Modal.confirm({
        content: `确定要${text}这${rows.length}台设备的代理吗`,
        onOk: async () => resolve(true),
        onCancel: () => resolve(false),
      });
    });
    if (confirm) {
      const res = await request('/management/device/batchUpdate', {
        ids: rows.map((i: any) => i.id),
        data: {proxySetting},
      });
      if (res) {
        await this.refreshList();
      }
    }
  }
}
